<template>
  <div>
    <h5>Taxation</h5>
    <p class="">
      <a :href="mfRecosLink">Click here</a> to read about the taxation of mutual
      funds - last updated March - 2024
    </p>
  </div>
</template>
<script setup>
import { computed } from 'vue'

const mfRecosLink = computed(
  () => `${process.env.VUE_APP_BASE_URL}/reports/mutual-fund-taxation-a-guide/`
)
</script>
